// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lh1u","title":"Info_title__1yo2J","links":"Info_links__3Vj55","link":"Info_link__29BuW","logo":"Info_logo__3S1Le"};